import React from 'react';
import { BookOpen, Bell, MessageCircle, Moon, BookMarked, Clock, Users, Star } from 'lucide-react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: <Star size={32} />,
      title: 'روزانہ ایک اچھی بات',
      description: 'ہر روز ایک نیا حکمت بھرا پیغام جو آپ کے دن کو روشن کرے',
      color: '#FAAA17'
    },
    {
      icon: <Bell size={32} />,
      title: 'یادہانی',
      description: 'عمل ایپ استعمال کرنے کے لیے بروقت یاد دہانیاں لگائیں',
      color: '#1A9286'
    },
    {
      icon: <BookOpen size={32} />,
      title: 'قرآن کی تفصیل',
      description: 'قرآن پاک کی آیات کا اردو ترجمہ اور تفسیر کے ساتھ مطالعہ',
      color: '#E74C3C'
    },
    {
      icon: <MessageCircle size={32} />,
      title: 'دعائیں',
      description: 'روز کی ایک دعا یاد کریں',
      color: '#9B59B6'
    },
    {
      icon: <BookMarked size={32} />,
      title: 'احادیث نبوی',
      description: 'روز کی ایک حدیث یاد کریں',
      color: '#3498DB'
    },
    {
      icon: <Moon size={32} />,
      title: 'ایک دن ایک رکوع',
      description: 'روز قرآن کے ایک رکوع کا ترجمہ پڑھیں اور اپنا جائزہ لیں',
      color: '#1ABC9C'
    },
    {
      icon: <Clock size={32} />,
      title: 'نماز سمجھیں',
      description: 'نماز کے ترجمے کو سمجھ کر پڑھیں اور خشوع پیدا کریں',
      color: '#F39C12'
    },
    {
      icon: <Users size={32} />,
      title: 'سنت رسول',
      description: 'روز ایک سنت کو اپنے معمول کا حصہ بنائیں',
      color: '#E91E63'
    }
  ];

  return (
    <section className="features section" id="features">
      <div className="container">
        <div className="section-title">
          <h2>خصوصیات</h2>
          <p>عمل ایپ کی تمام خصوصیات جو آپ کی عبادت میں مدد کریں</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div 
                className="feature-icon" 
                style={{ backgroundColor: `${feature.color}15`, color: feature.color }}
              >
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
              <div className="feature-glow" style={{ background: feature.color }}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
